import { Fade, Bounce } from "react-reveal";

import CONSTANTS from "../../utils/constants/CONSTANTS";

import "./index.scss";

const NewsSection = () => (
  <div className="news-section">
    <Fade left >
      <div className="news-heading">AS SEEN ON</div>
    </Fade>
    <Bounce bottom>
      <div className="news-images">
        {CONSTANTS.newsChannels.map((value) => (
          <img className="news-image" src={value.img} alt="" />
        ))}
      </div>
    </Bounce>
  </div>
);
export default NewsSection;
